import { assertString } from "../utils/assertions";
import { createUuid } from "../utils/id";
import { nowIso } from "../utils/timestamps";

export const GENERATED_DOCUMENT_DELIVERY_STATUSES = Object.freeze({
  LOCAL_ONLY: "local_only",
  PENDING_UPLOAD: "pending_upload",
  UPLOADED: "uploaded",
  PENDING_EMAIL: "pending_email",
  EMAILED: "emailed",
  FAILED: "failed",
});

/** Creates an immutable local record of the exact document output. */
export const createGeneratedDocument = ({
  id = createUuid(),
  organizationId,
  vesselId,
  voyageId = null,
  tripId = null,
  cargoId = null,
  templateId,
  documentTitle,
  generatedAt = nowIso(),
  generatedByUserId = null,
  sourceRevision = null,
  viewModelSnapshot = {},
  html,
  deliveryStatus = GENERATED_DOCUMENT_DELIVERY_STATUSES.LOCAL_ONLY,
}) => {
  assertString(id, "generatedDocument.id");
  assertString(organizationId, "generatedDocument.organizationId");
  assertString(vesselId, "generatedDocument.vesselId");
  assertString(templateId, "generatedDocument.templateId");
  assertString(documentTitle, "generatedDocument.documentTitle");
  assertString(html, "generatedDocument.html");

  if (!Object.values(GENERATED_DOCUMENT_DELIVERY_STATUSES).includes(deliveryStatus)) {
    throw new Error("generatedDocument.deliveryStatus must be valid");
  }

  return {
    id,
    organizationId,
    vesselId,
    voyageId,
    tripId,
    cargoId,
    templateId,
    documentTitle,
    generatedAt,
    generatedByUserId,
    sourceRevision,
    viewModelSnapshot,
    html,
    deliveryStatus,
    lastDeliveryError: null,
    updatedAt: generatedAt,
    schemaVersion: 1,
  };
};
